export const Logo = ({ className = "", size = "md", tone = "brown" }) => {
  const sizeClass =
    size === "sm" ? "text-sm" : size === "lg" ? "text-3xl" : "text-xl";
  const toneClass = tone === "cream" ? "text-brand-cream" : "text-brand-brown";
  return (
    <span
      className={`wordmark ${sizeClass} ${toneClass} ${className}`}
      data-testid="aristeia-logo"
    >
      ARISTEIA
    </span>
  );
};

export default Logo;
